import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import svgArrow from '@img/icons/nav-arrow-down.svg';
import styled from 'styled-components';
const Container = styled.div `
  position: relative;
  flex: 0 0 100%;

  &::after {
    ${transition('transform')};

    display: block;
    content: url('${svgArrow}');
    width: 18px;
    height: 12px;
    position: absolute;
    right: 24px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }

  &[data-is-open='true']::after {
    transform: translateY(-50%) rotate(0.5turn);
  }

  @media ${from(Device.Tablet)} {
    flex: 0 0 calc(25% - var(--filterGap));
  }
`;
const Select = styled.select `
  /* Ensure iOS doesn't apply default border radius */
  -webkit-appearance: none !important;
  ${fonts.brandonGrotesque.bold};
  height: 54px;
  padding: 0 48px 0 12px;
  font-size: 18px;
  border: 2px solid ${brand.greenBright};
  appearance: none;
  width: 100%;

  &.focus-ring {
    outline: auto;
    outline-offset: -5px;
    outline-width: 2px;
    outline-style: solid;
  }
`;
const DropdownStyles = {
    Container,
    Select,
};
export default DropdownStyles;
